import type { ReactElement } from 'react';
import { CategoryGridItemSchema } from '@amplience/content-types';
import { CategoryGridItem } from '@storefront/lib-content/components/categoryGridItem/CategoryGridItem';

export const SRPAmplienceComponents: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: (props: any) => ReactElement | null;
} = {
  [CategoryGridItemSchema.$id]: CategoryGridItem,
};
